import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "src/store";

import {
  AreaType,
  CustomerGroupFilterState,
  DashboardFilterState,
  GasFilter,
  ProductType,
  SupplyType,
  Tariff,
  TernaryFilterOption,
} from "../../../types/index";
import { FilterGroup } from "../constants";
import FilterContainer from "../FilterContainer";
import CustomerTariffsFilter from "./CustomerTariffsFilter";
import {
  AreaTypeOptions,
  ContractExistingOptions,
  SupplyTypeOptions,
} from "./FilterOptions";
import ProductFamilyFilter from "./ProductFamilyFilter";

function mapStateToProps({ supplyTypesMappedToProductFamilies }: StoreState) {
  return {
    supplyTypesMappedToProductFamilies,
  };
}

type Props = {
  gasFilter: GasFilter;
  superordinateFilter: "CustomerGroupFilter" | "DashboardFilter";
  enabled: boolean;
  changeFilter: (
    payload: Partial<CustomerGroupFilterState> | Partial<DashboardFilterState>
  ) => void;
  handleEnabledChange: (filterGroup: FilterGroup, enabled: boolean) => void;
} & ReturnType<typeof mapStateToProps>;

class GasFilterComponent extends React.Component<Props> {
  private changeGasFilter = (changedPartsGasFilter: Partial<GasFilter>) => {
    this.props.changeFilter({
      gasFilter: {
        ...this.props.gasFilter,
        ...changedPartsGasFilter,
      },
    });
  };
  private changeContractFilter = (filter: TernaryFilterOption) => {
    this.changeGasFilter({ contractExistingFilter: filter });
  };

  private changeAreaFilter = (filter: AreaType | null) => {
    this.changeGasFilter({ areaTypeFilter: filter });
  };

  private changeSupplyFilter = (filter: SupplyType | null) => {
    const filteredTariffsSelection = filter
      ? this.props.gasFilter.tariffs.filter(
          (tariff) => tariff.supplyType === filter
        )
      : this.props.gasFilter.tariffs;
    const filteredProductFamilies = filter
      ? this.props.gasFilter.productFamilies.filter((productFamily) =>
          this.props.supplyTypesMappedToProductFamilies.gas[filter].includes(
            productFamily
          )
        )
      : this.props.gasFilter.productFamilies;
    this.changeGasFilter({
      supplyTypeFilter: filter,
      tariffs: filteredTariffsSelection,
      productFamilies: filteredProductFamilies,
    });
  };

  private changeFilterEnabled = (enabled: boolean) => {
    this.props.handleEnabledChange(FilterGroup.gas, enabled);
  };

  private changeTariffsFilter = (tariffs: Tariff[]) => {
    this.changeGasFilter({ tariffs });
  };

  private changeProductFamiliesFilter = (productFamilies: string[]) => {
    const filteredTariffs = productFamilies.length
      ? this.props.gasFilter.tariffs.filter((tariff) =>
          productFamilies.includes(tariff.productFamily)
        )
      : this.props.gasFilter.tariffs;

    this.changeGasFilter({
      productFamilies,
      tariffs: filteredTariffs,
    });
  };

  public render(): JSX.Element {
    return (
      <FilterContainer
        title="Gasverträge"
        enabled={this.props.enabled}
        onEnabledChange={this.changeFilterEnabled}
      >
        {(disabled?: boolean) => (
          <>
            <ContractExistingOptions
              contractExistingFilterState={
                this.props.gasFilter.contractExistingFilter
              }
              onChange={this.changeContractFilter}
              disabled={disabled}
            />
            <AreaTypeOptions
              areaTypeFilterState={this.props.gasFilter.areaTypeFilter}
              onChange={this.changeAreaFilter}
              disabled={disabled}
            />
            <SupplyTypeOptions
              supplyTypeFilterState={this.props.gasFilter.supplyTypeFilter}
              onChange={this.changeSupplyFilter}
              disabled={disabled}
            />
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <ProductFamilyFilter
                productTypeFilter={this.props.gasFilter}
                onChange={this.changeProductFamiliesFilter}
                productType={ProductType.GAS}
              />
            )}
            {this.props.superordinateFilter === "CustomerGroupFilter" && (
              <CustomerTariffsFilter
                productTypeFilter={this.props.gasFilter}
                onChange={this.changeTariffsFilter}
                productType={ProductType.GAS}
                disabled={disabled}
              />
            )}
          </>
        )}
      </FilterContainer>
    );
  }
}

export default connect(mapStateToProps)(GasFilterComponent);



// WEBPACK FOOTER //
// ./src/components/Filters/ProductTypeFilter/GasFilter.tsx